module.exports = __webpack_public_path__ + "assets/img/kate.1652eddd.jpeg";